export default function CoverageSection() {
  const locations = [
    {
      city: 'Ibagué, Tolima',
      address: 'Calle 10 a 3 – 56, Edificio Seapto, Oficina 603',
      icon: 'ri-map-pin-line',
      schedule: [
        { days: 'Lunes a Viernes', hours: '8:00 a.m. - 6:00 p.m.' },
        { days: 'Sábados', hours: '8:00 a.m. - 3:00 p.m.' }
      ]
    },
    {
      city: 'Bogotá, Cundinamarca',
      address: 'Cra 30 #15 – 30, Call center',
      icon: 'ri-map-pin-line',
      schedule: [
        { days: 'Lunes a Viernes', hours: '8:00 a.m. - 6:00 p.m.' },
        { days: 'Sábados', hours: '8:00 a.m. - 3:00 p.m.' }
      ]
    }
  ];

  return (
    <section id="cobertura" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full mb-6">
              <i className="ri-map-pin-line text-3xl text-amber-600"></i>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Cobertura Nacional</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Presencia en las principales ciudades de Colombia para brindarte un servicio cercano y eficiente
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {locations.map((location, index) => (
              <div 
                key={index}
                className="bg-white p-8 rounded-xl shadow-xl hover:shadow-2xl transition-all border-t-4 border-gray-800"
              >
                <div className="flex items-center gap-4 mb-6">
                  <div className="flex items-center justify-center w-16 h-16 bg-gray-800 rounded-full flex-shrink-0">
                    <i className={`${location.icon} text-3xl text-white`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-black">{location.city}</h3>
                </div>
                
                <div className="mb-6">
                  <div className="flex items-start gap-3 mb-4">
                    <i className="ri-map-pin-2-fill text-gray-800 text-xl mt-1 flex-shrink-0"></i>
                    <p className="text-gray-700 leading-relaxed">{location.address}</p>
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-6">
                  <div className="flex items-center gap-2 mb-4">
                    <i className="ri-time-line text-gray-800 text-2xl"></i>
                    <h4 className="font-bold text-black">Horarios de Atención</h4>
                  </div>
                  {location.schedule.map((schedule, idx) => (
                    <div key={idx} className="flex items-center justify-between mb-2 text-gray-700">
                      <span className="font-medium">{schedule.days}:</span>
                      <span>{schedule.hours}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
